export enum StartProjectDetailListSortType {
    Id,
    AssignedEmployeeFullName,
    Title,
    ProjectStatus,
    CustomerName,
    ProjectName,
    IsDeleted
}
